// extracted by mini-css-extract-plugin
export default {"container":"Layout_container__1CjX1","table":"Layout_table__AK3Pc","footer_table":"Layout_footer_table__BM1Ap"};